import { ToggleButton, ToggleButtonGroup, Typography } from '@mui/material'
import { HelperWrapper } from 'src/components/helper-wrapper'

import { EAccountSubscriptionPlans } from 'src/types'
import { useStyles } from './styles'

interface IProps {
  handleChange: (
    event: React.MouseEvent<HTMLElement>,
    newSubscription: EAccountSubscriptionPlans,
  ) => void
  value: EAccountSubscriptionPlans | null
  plusOptionDisabled?: boolean
}

export const SubscriptionPlanPicker = ({ handleChange, value, plusOptionDisabled }: IProps) => {
  const classes = useStyles()

  return (
    <div className={classes.itemWrapper}>
      <Typography className={classes.itemTitle}>
        <HelperWrapper t="subscribe-form-plan" />
      </Typography>
      <ToggleButtonGroup color="primary" exclusive value={value} onChange={handleChange}>
        <ToggleButton disabled={plusOptionDisabled} value={EAccountSubscriptionPlans.plus}>
          Plus
        </ToggleButton>
        <ToggleButton value={EAccountSubscriptionPlans.premium}>Premium</ToggleButton>
      </ToggleButtonGroup>
    </div>
  )
}
